<script lang="ts">
    import { onMount } from "svelte";
    import { storePodcastCategory } from "../scripts/classes/podcast";
    import { redirectTo } from "../scripts/router1";
    import { idPagePodcastsCategory, idPagePodcastCategories } from "../scripts/router2";
    import { PODCAST_CATEGORY_1, PODCAST_CATEGORY_2, PODCAST_CATEGORY_3 } from '../scripts/constant';

    onMount(async () => {
    })

    function selectCategory(category: string) {
        storePodcastCategory.set(category);
        let param = "?id="+category
        redirectTo(idPagePodcastsCategory, param);
    }
</script>
    
<style lang="scss">

    .podcastCategories {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        margin: 100px 0 0 0;
        &__category {
            display: flex;
            flex-direction: column;
            justify-content: stretch;
            align-items: center;
            border-radius: 50%;
            background-color: $color_primary;
            color: $color_secondary;
            width: 80vw;
            margin: 0 0 150px 0;
            &__image {
                border-radius: 50%;
                width: 100%;
                min-height: 300px;
            }
            &__h2 {
                font-size: 30px;
                z-index: 1;
                color: $color_secondary;
                text-align: center;
            }
            &__link {
                height: 40px;
                width: 40px;
            }
            &__text {
                font-size: 20px;
                z-index: 1;
                color: $color_secondary;
            }
        }
    }


    @include large {
        .podcastCategories {
            width: 90%;
            display: grid;
            grid-template-columns: 30% 30% 30%;
            gap: 5%;
            &__category {
                width: 300px;
                height: 300px;
                margin: 100px 0 0 0;
                cursor: pointer;
                transition: all 0.5s;
                &__image {
                    filter: grayscale(1);
                    transition: all 0.5s;
                }
                &__h2 {
                    font-size: 25px;
                    z-index: 1;
                }
                &__link {
                    display: none;
                }
                &__text {
                    font-size: 20px;
                }
                &:hover {
                    border: 5px $color_tertiary;
                    box-shadow: 5px 5px 40px 5px $color_secondary;
                }
                &:hover > img {
                    filter: grayscale(0);
                }
                &:hover > h2 {
                    text-shadow: -2px 0 10px $color_tertiary, 0 2px 10px $color_tertiary, 2px 0 10px $color_tertiary, 0 -2px 10px $color_tertiary;
                }
            }
        }

    }

</style>

<div class="page">
    <div class="podcastCategories">
        <div class="podcastCategories__category" on:click={() => selectCategory("1")} on:keydown={() => selectCategory("1")}>
            <img class="podcastCategories__category__image" src="../assets/images/categorie1.jpg" alt={PODCAST_CATEGORY_1.label}>
            <h2 class="podcastCategories__category__h2">{PODCAST_CATEGORY_1.label}</h2>
            <div class="podcastCategories__category__text">{PODCAST_CATEGORY_1.texte}</div>
            <div class="link"></div>
        </div>
        <div class="podcastCategories__category" on:click={() => selectCategory("2")} on:keydown={() => selectCategory("2")}>
            <img class="podcastCategories__category__image" src="../assets/images/categorie2.jpg" alt={PODCAST_CATEGORY_2.label}>
            <h2 class="podcastCategories__category__h2">{PODCAST_CATEGORY_2.label}</h2>
            <div class="podcastCategories__category__text">{PODCAST_CATEGORY_2.texte}</div>
            <div class="link"></div>
        </div>
        <div class="podcastCategories__category" on:click={() => selectCategory("3")} on:keydown={() => selectCategory("3")}>
            <img class="podcastCategories__category__image" src="../assets/images/categorie3.jpg" alt={PODCAST_CATEGORY_3.label}>
            <h2 class="podcastCategories__category__h2">{PODCAST_CATEGORY_3.label}</h2>
            <div class="podcastCategories__category__text">{PODCAST_CATEGORY_3.texte}</div>
            <div class="link"></div>
        </div>
    </div>
</div>